// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3zCYC","row":"footer-module--row--1LDWH","contact":"footer-module--contact--2rpi3"};